"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ApptPurposeSkeleton;
var _react = _interopRequireDefault(require("react"));
var _styles = require("./styles");
function ApptPurposeSkeleton() {
  return /*#__PURE__*/_react.default.createElement(_styles.LoadingContainer, {
    "data-testid": "Loading"
  }, /*#__PURE__*/_react.default.createElement(_styles.LoadingPurpose, null), /*#__PURE__*/_react.default.createElement(_styles.LoadingPurpose, null));
}
ApptPurposeSkeleton.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ApptPurposeSkeleton"
};